const submitManuscript = () => import('../views/author/submit-manuscripts')
const submittedManuscript = () =>
  import('../views/author/submitted-manuscripts')
const coAuthorManuscript = () => import('../views/author/co-author-manuscripts')
const authorReport = () =>
  import('../views/author/submitted-manuscripts/author-report')
const manuscriptInformation = () =>
  import('../views/author/submit-manuscripts/manuscript-information')
const authorInformation = () =>
  import('../views/author/submit-manuscripts/author-information')
const suggestOpposeReviewers = () =>
  import('../views/author/submit-manuscripts/suggest-oppose-reviewers')
const uploadDocuments = () =>
  import('../views/author/submit-manuscripts/upload-documents')
const confirmationSubmission = () =>
  import('../views/author/submit-manuscripts/confirmation-submission')

const authorRevised = () =>
  import('../views/author/submitted-manuscripts/author-revised')

const replay = () =>
  import('../views/author/submitted-manuscripts/author-revised/replay')

const path = '/author'

export default [
  {
    path: path + '/submit-manuscripts',
    component: submitManuscript,
    name: '/author/submit-manuscripts',
    children: [
      {
        path: path + '/submit-manuscripts/step1',
        component: manuscriptInformation,
        name: '/author/submit-manuscripts/step1'
      },
      {
        path: path + '/submit-manuscripts/step2',
        component: authorInformation,
        name: '/author/submit-manuscripts/step2'
      },
      {
        path: path + '/submit-manuscripts/step3',
        component: uploadDocuments,
        name: '/author/submit-manuscripts/step4'
      },
      {
        path: path + '/submit-manuscripts/step4',
        component: suggestOpposeReviewers,
        name: '/author/submit-manuscripts/step3'
      },
      {
        path: path + '/submit-manuscripts/step5',
        component: confirmationSubmission,
        name: '/author/submit-manuscripts/step5'
      }
    ]
  },
  {
    path: path + '/submitted-manuscripts',
    component: submittedManuscript,
    name: '/author/submitted-manuscripts'
  },
  {
    path: path + '/co-author-manuscripts',
    component: coAuthorManuscript,
    name: '/author/co-author-manuscripts'
  },
  {
    path: path + '/co-author-manuscripts/view-decision',
    component: authorReport,
    name: '/author/co-author-manuscripts/view-decision'
  },
  {
    path: path + '/submitted-manuscripts/author-revised',
    component: authorRevised,
    name: '/author/submitted-manuscripts/author-revised'
  },
  // 查看决策 View the decision
  {
    path: path + '/submitted-manuscripts/author-report',
    component: authorReport,
    name: '/author/submitted-manuscripts/author-report'
  },
  {
    path: path + '/submitted-manuscripts/author-revised/replay/:id',
    component: replay,
    name: '/author/submitted-manuscripts/author-revised/replay'
  }
  // {
  //   path: path + '/submitted-author/report/:id',
  //   component: replay,
  //   name: '/author/submitted-author/report'
  // }
]
